import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiHome, FiInbox, FiUsers, FiBell, FiBarChart2, FiSettings } from "react-icons/fi";
import { MdQrCode } from "react-icons/md";
import logo from "../assets/TravelXOXO 2.png"

const Navigation = ({ activeScreen, setActiveScreen, theme, toggleTheme }) => {
  const location = useLocation();

 const links = [
  { key: "dashboard", title: "Dashboard", path: "/dashboard", section: "Main", icon: <FiHome /> },

  { key: "qrcodes", title: "QR Codes", path: "/qrcodes", section: "Main", icon: <MdQrCode /> },
  { key: "create", title: "Create QR Code", path: "/create", section: "Management", icon: <FiBell /> },
  { key: "users", title: "Users", path: "/users", section: "Management", icon: <FiUsers /> },
  { key: "requests", title: "Requests", path: "/requests", section: "Management", icon: <FiInbox /> }, // ✅ added

  { key: "analytics", title: "Analytics", path: "/analytics", section: "Management", icon: <FiBarChart2 /> },
  { key: "settings", title: "Settings", path: "/settings", section: "System", icon: <FiSettings /> },
];


  return (
    <aside className="w-20 md:w-64 bg-gray-900 dark:bg-black text-gray-300 dark:text-gray-200 flex flex-col justify-between fixed h-full overflow-y-auto transition-all duration-300 z-10">
      <div>
        {/* Logo Section */}
        <div className="p-6 pb-4 border-b border-gray-800">
         
          <img
  src={logo}
  alt="Travelxoxo Logo"
  className="h-10 w-auto object-contain"
/>

          <div className="hidden md:block text-xs uppercase font-semibold text-gray-500 mt-1 tracking-wider">
            Admin Panel
          </div>
        </div>

        {/* Navigation Links */}
        <nav className="p-3 md:p-4 space-y-1">
          {["Main", "Management", "System"].map((section) => (
            <div key={section}>
              <div className="hidden md:block text-xs font-bold uppercase text-gray-500 mb-2">{section}</div>
              {links
                .filter((link) => link.section === section)
                .map((link) => (
                  <Link
                    key={link.key}
                    to={link.path}
                    className={`flex items-center space-x-3 p-3 rounded-xl font-medium transition-colors duration-150 ${
                      location.pathname === link.path
                        ? "bg-orange-600 text-white shadow-lg shadow-orange-500/50"
                        : "hover:bg-gray-800 text-gray-300 hover:text-white"
                    }`}
                    onClick={() => setActiveScreen(link.key)}
                  >
                    <span className="text-lg">{link.icon}</span>
                    <span className="hidden md:inline text-sm">{link.title}</span>
                  </Link>
                ))}
            </div>
          ))}
        </nav>
      </div>

      {/* Theme Toggle Button at Bottom */}
      <div className="p-4 border-t border-gray-800">
        <button
          onClick={toggleTheme}
          className="w-full bg-gray-700 dark:bg-gray-200 text-white dark:text-black py-2 rounded-lg hover:bg-gray-600 dark:hover:bg-gray-300 transition-colors"
        >
          {theme === "dark" ? "☀️ Light Mode" : "🌙 Dark Mode"}
        </button>
      </div>
    </aside>
  );
};

export default Navigation;
